import type { ReactNode } from 'react';
import { TenantDiscoveryLayout } from '@/config/siteShell';
import { isOpsItsmBuild } from '@/platform/servicedesk/isOpsItsmBuild';
import {
  SitePageLayout,
  type SitePageLayoutProps,
} from './SitePageLayout';

export type { PageBackLinkProps } from './SitePageLayout';
export { PageBackLink } from './SitePageLayout';

export type SiteShellProps = SitePageLayoutProps & {
  right?: ReactNode;
  hideSidebar?: boolean;
};

export function opsSkipsDiscoveryLayout(opsFlag: string | undefined = process.env.NEXT_PUBLIC_COMMUNIO_OPS): boolean {
  return isOpsItsmBuild(opsFlag);
}

/**
 * Communio standard page shell: tenant sidebar/grid + page header template.
 * Tenant chrome is wired via web/config/siteShell.tsx at deploy time.
 */
export function SiteShell({
  children,
  right,
  hideSidebar,
  ...page
}: SiteShellProps) {
  if (opsSkipsDiscoveryLayout()) {
    return <SitePageLayout {...page}>{children}</SitePageLayout>;
  }
  return (
    <TenantDiscoveryLayout right={right} hideSidebar={hideSidebar}>
      <SitePageLayout {...page}>{children}</SitePageLayout>
    </TenantDiscoveryLayout>
  );
}

/** @deprecated Prefer SiteShell — kept for incremental migration. */
export const DiscoveryPageLayout = SiteShell;
export type DiscoveryPageLayoutProps = SiteShellProps;
